import { useGraphQLQuery } from '@betterment/graphql';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { LegalAccountTaxationType } from '../../../graphql/schema';
import IraContributionsOverviewCard from '../../../IraContributionsOverviewCard';
import { EnvelopeAccountSubAccountTypesDocument } from '../../graphql/envelopeAccountSubAccountTypes.generated';

export const IraContributionsCard: React.FC = () => {
  const accountId = useRequiredParam('accountId');
  const { data } = useGraphQLQuery(EnvelopeAccountSubAccountTypesDocument, { variables: { accountId } });

  if (!data) return <CardLoader />;
  if (data.account.__typename !== 'ManagedAccount') return null;

  const taxationTypes = new Set([LegalAccountTaxationType.RothIra, LegalAccountTaxationType.TraditionalIra]);

  if (!data.account.subAccounts.map(a => a.legalAccount.taxationType).some(t => taxationTypes.has(t))) return null;

  return (
    <ErrorBoundary fallbackType="none">
      <IraContributionsOverviewCard />
    </ErrorBoundary>
  );
};
